import page from 'page';
import { isFunction, isString } from 'lodash';
import abPagejsCallback from '../utils';

// Extends page.exit to support full ab but also maintains compatibility with
// default page.exit behavior:
//   1. page.exit(path, callback[, callback ...])
//      https://visionmedia.github.io/page.js/#pageexitpath-callback-callback-
//   2. page.exit(callback)
//      https://visionmedia.github.io/page.js/#pageexitcallback
export default (...args) => {
  const pageExitArgs = convertToPageExit(args);
  page.exit(...pageExitArgs);
};

function convertToPageExit(args) {
  const getAbExitArgs = isAbExit(args);
  const getNormalExitArgs = isNormalExit(args);
  const getShorthandExitArgs = isShorthandExit(args);

  // page.exit(abVariation, path, callback[, callback ...])
  if (getAbExitArgs) {
    return getAbExitArgs();
  }

  // page.exit(path, callback[, callback ...])
  if (getNormalExitArgs) {
    return getNormalExitArgs();
  }

  // page.exit(callback)
  if (getShorthandExitArgs) {
    return getShorthandExitArgs();
  }

  // It never should arrive to here
  return new Error('page.exit cannot be called without params.');
}

// page.exit(abVariation, path, callback[, callback ...])
function isAbExit(args) {
  const isAb = isString(args[0]) && isString(args[1]) && isFunction(args[2]);

  if (!isAb) return null;

  return () => {
    const variantName = args[0];
    const path = args[1];
    const callbacks = args.slice(2);
    const newCallbacks = callbacks.map(callback => abPagejsCallback(callback, variantName));
    const pageExitArgs = [path, ...newCallbacks];

    return pageExitArgs;
  };
}

// page.exit(path, callback[, callback ...])
function isNormalExit(args) {
  const isNormal = isString(args[0]) && isFunction(args[1]);

  if (!isNormal) return null;

  return () => {
    const variantName = 'original';
    const path = args[0];
    const callbacks = args.slice(1);
    const newCallbacks = callbacks.map(callback => abPagejsCallback(callback, variantName));
    const pageExitArgs = [path, ...newCallbacks];

    return pageExitArgs;
  };
}

// page.exit(callback)
function isShorthandExit(args) {
  const isShorthand = isFunction(args[0]);

  if (!isShorthand) return null;

  return () => args;
}



// WEBPACK FOOTER //
// ./src/modules/ab-page-js/page-exit/index.js